import {
    WikiArticleDownloadDto,
    WikiColumnSearchResultDto,
    WikiSearchResultDto,
    WikiSectionSearchResultDto,
} from 'collaboration-service';
import { getTranslated } from 'services/Helpers/TranslationHelpers';

export const getRidOfHtml = (html?: string): string => {
    if (!html) return '';
    return html.replace(/<[^>]*>?/gm, '');
};

export const toWikiSearchResult = (
    a: WikiArticleDownloadDto,
    contentLanguage: string | undefined
): WikiSearchResultDto => {
    const sections: WikiSectionSearchResultDto[] = a.sections.map(s => {
        const columns: WikiColumnSearchResultDto[] = s.columns.map(c => ({
            title: getTranslated(c.title, contentLanguage).text,
            id: c.id,
        } as WikiColumnSearchResultDto));
        return {
            title: getTranslated(s.title, contentLanguage).text,
            id: s.id,
            columns,
        } as WikiSectionSearchResultDto;
    });
    return {
        headline: getTranslated(a.headlines, contentLanguage).text,
        id: a.id,
        sections,
        score: 0,
    };
};
